// Pengganti DisboxFileManager untuk halaman Anime publik (/nonton): isinya
// HANYA folder anime yang dikirim bot (GET /a/library, lihat
// discord-bot/public-anime.js), tanpa login, webhook, atau data potongan file.
// Menyediakan bagian yang dipakai AnimePage & VideoPlayer saja (baca-saja).
import { FILE_DELIMITER } from './disbox-file-manager';
import { fileUrl, publicApiBase, setPublicMode } from './api.js';

export const PUBLIC_USER_ID = 'publik';

export default class PublicLibrary {
    static async load() {
        const base = publicApiBase();
        setPublicMode(base);
        const response = await fetch(`${base}/library`, { cache: 'no-cache' });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.error || `Server membalas status ${response.status}`);
        return new PublicLibrary(data.root, data.tree, data.anilist);
    }

    constructor(root, tree, anilist = {}) {
        this.userId = PUBLIC_USER_ID;
        this.root = root;
        // Padanan folder seri -> ID/judul AniList yang diatur admin di bot.
        this.anilist = anilist || {};
        // Tree lengkap dari akar supaya path sama persis dengan di akun
        // ("/ANIME/Seri/ep.mkv"); di luar folder anime tidak ada apa-apa.
        const segments = root.split(FILE_DELIMITER).filter(Boolean);
        let node = tree;
        for (let i = segments.length - 1; i >= 1; i--) {
            node = { name: segments[i - 1], type: 'directory', children: { [segments[i]]: node } };
        }
        this.fileTree = { name: 'root', type: 'directory', children: { [segments[0]]: node } };
    }

    getFile(path, copy = true) {
        let file = this.fileTree;
        for (const part of path.split(FILE_DELIMITER).slice(1)) {
            if (file.children && Object.prototype.hasOwnProperty.call(file.children, part)) file = file.children[part];
            else return null;
        }
        return copy ? { ...file, path } : file;
    }

    getChildren(path) {
        const dir = path === '' ? this.fileTree : this.getFile(path, false);
        if (!dir) throw new Error(`File not found: ${path}`);
        if (dir.type !== 'directory') throw new Error(`File is not a directory: ${path}`);
        const result = {};
        for (const [name, child] of Object.entries(dir.children || {})) {
            result[name] = { ...child, path: `${path}${FILE_DELIMITER}${name}` };
        }
        return result;
    }

    // Subtitle di sebelah video (dipakai VideoPlayer).
    async getPreviewBlob(path, mimeType) {
        const response = await fetch(fileUrl('stream', this.userId, path));
        if (!response.ok) throw new Error(`Gagal mengambil file (status ${response.status})`);
        const blob = await response.blob();
        return mimeType ? new Blob([blob], { type: mimeType }) : blob;
    }

    subscribe() {
        return () => {};
    }
}
